import { get } from 'lodash';
import { getButtonMaxWidth, getButtonMinWidth } from '../../utils/button-utils';
import * as cssUtils from '../../utils/css-utils';
import { extractButton } from '../../utils/elements';
export var getButtonSection = function (_a) {
    var composerData = _a.composerData, experiments = _a.experiments, isRtl = _a.isRtl, region = _a.region, css = _a.css;
    var customStyles = get(region, 'data.styles.main', {});
    var defaultStyles = composerData.styles.css['so-global-b1'];
    var rules = [
        get(region, 'data.styles.region', {}),
        css['so-global-region-button'],
        css['so-global-region'],
    ];
    var mobileCssClass = cssUtils.getRegionMobileCssClass(rules, true);
    var padding = cssUtils.padding(rules);
    var margin = cssUtils.margin(rules);
    var minWidth = getButtonMinWidth(composerData.styles.css, '0px');
    var maxWidth = getButtonMaxWidth(composerData.styles.css);
    var button = extractButton({
        customStyles: customStyles,
        defaultStyles: defaultStyles,
        experiments: experiments,
        isRtl: isRtl,
        region: region,
    });
    return {
        cssClass: mobileCssClass,
        button: button,
        minWidth: minWidth,
        maxWidth: maxWidth,
        outerPadding: margin,
        innerPadding: padding,
    };
};
//# sourceMappingURL=get-button-section.js.map